class ThoosieCarousel {
  constructor(element) {
    this.element = element;
    this.slides = Array.from(element.querySelectorAll('[data-thoosie-slide]'));
    this.dots = Array.from(element.querySelectorAll('[data-thoosie-dot]'));
    this.prev = element.querySelector('[data-thoosie-prev]');
    this.next = element.querySelector('[data-thoosie-next]');
    this.index = 0;
    this.timer = null;
    this.startX = 0;
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplay = element.dataset.autoplay === 'true' && !this.reducedMotion;
    this.speed = Number(element.dataset.speed || 6000);
    this.bind();
    this.show(0);
    this.start();
  }

  bind() {
    if (this.prev) this.prev.addEventListener('click', () => this.show(this.index - 1, true));
    if (this.next) this.next.addEventListener('click', () => this.show(this.index + 1, true));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => this.show(Number(dot.dataset.slideIndex), true));
    });

    this.element.addEventListener('mouseenter', () => this.pause());
    this.element.addEventListener('mouseleave', () => this.start());
    this.element.addEventListener('focusin', () => this.pause());
    this.element.addEventListener('focusout', () => this.start());
    this.element.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.show(this.index - 1, true);
      if (event.key === 'ArrowRight') this.show(this.index + 1, true);
    });

    this.element.addEventListener(
      'touchstart',
      (event) => {
        this.startX = event.touches[0].clientX;
      },
      { passive: true }
    );

    this.element.addEventListener(
      'touchend',
      (event) => {
        const endX = event.changedTouches[0].clientX;
        const delta = endX - this.startX;
        if (Math.abs(delta) > 40) this.show(this.index + (delta < 0 ? 1 : -1), true);
      },
      { passive: true }
    );
  }

  show(nextIndex, userAction = false) {
    if (this.slides.length === 0) return;
    this.index = (nextIndex + this.slides.length) % this.slides.length;

    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.index;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (userAction) {
      this.pause();
      this.start();
    }
  }

  start() {
    this.pause();
    if (!this.autoplay || this.slides.length < 2) return;
    this.timer = window.setInterval(() => this.show(this.index + 1), this.speed);
  }

  pause() {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  }
}

const initThoosieCarousels = (root = document) => {
  root.querySelectorAll('[data-thoosie-carousel]').forEach((element) => {
    if (!element.dataset.thoosieInitialized) {
      element.dataset.thoosieInitialized = 'true';
      new ThoosieCarousel(element);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => initThoosieCarousels());
document.addEventListener('shopify:section:load', (event) => initThoosieCarousels(event.target));
